module.exports = __webpack_public_path__ + "img/camera-video-fill.9f4f64fd.svg";